import React from 'react';
import { Card, CardContent, Typography, Box, useMediaQuery } from '@mui/material';
import Chart from 'react-apexcharts';
import { theme } from '../../../theme/DashboardTheme';

interface ScanCoverageCardProps {
  unmatchedBrokersCount: number;
  totalBrokers: number;
}

const ScanCoverageCard: React.FC<ScanCoverageCardProps> = ({
  unmatchedBrokersCount,
  totalBrokers,
}) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const progress = (unmatchedBrokersCount / totalBrokers) * 100;

  return (
    <Card
      sx={{
        borderRadius: '16px',
        boxShadow: '0px 4px 10px rgba(208, 210, 218, 0.37)',
        height: isMobile ? 'auto' : '100%',
        minHeight: isMobile ? 'auto' : 261,
        minWidth: isMobile ? 'unset' : 275,
        display: 'flex',
        justifyContent: 'center',
        overflow: 'hidden',
        background: '#FFFFFF',
        pb: isMobile ? 3 : 0,
      }}
    >
      <CardContent
        sx={{
          '&:last-child': { pb: 1 },
          width: '100%',
        }}
      >

        {/* Header */}
        <Box display="flex" justifyContent="center" sx={{ mb: 0, mt: 1.5 }}>
          <Typography
            sx={{
              fontFamily: 'InterSemiBold',
              fontSize: { xs: 18, lg: 13, xl: 18 },
              fontWeight: 600,
              color: '#000',
            }}
          >
            Scan Coverage
          </Typography>
        </Box>

        {/* Semi-circle progress */}
        <Box position="relative" display="flex" justifyContent="center">
          <Chart
            options={{
              chart: {
                type: 'radialBar',
                sparkline: { enabled: true },
                offsetY: isMobile ? -5 : -12,
              },
              plotOptions: {
                radialBar: {
                  startAngle: -90,
                  endAngle: 90,
                  track: {
                    background: '#E3DEF7',
                    strokeWidth: '90%',
                  },
                  hollow: {
                    margin: 0,
                    size: '65%',
                    background: 'transparent',
                  },
                  dataLabels: {
                    show: false,
                  },
                },
              },
              fill: {
                colors: ['#7459D9'],
                opacity: 1
              },
              stroke: {
                lineCap: 'round',
              },
              labels: [],
            }}
            series={[progress]}
            type="radialBar"
            height={isMobile ? 220 : 260}
            width={isMobile ? 260 : 300}
          />
          <Box
            position="absolute"
            top={0}
            left={0}
            width="100%"
            height="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
          // mt={isMobile ? 4 : 1}
          >
            <Typography sx={{ fontSize: '26px', fontWeight: 700, lineHeight: '0.7', fontFamily: 'InterRegular', color: '#11263C' }}>
              {unmatchedBrokersCount}
            </Typography>
            <Typography sx={{ fontSize: { xs: 16, lg: 13, xl: 16 }, fontWeight: 500, fontFamily: 'InterRegular', color: '#11263C' }}>
              Clean Scans
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, color: "#000000", mt: isMobile ? -22 : -28 }}>
          <Typography sx={{ fontFamily: "InterRegular", fontSize: 14, fontWeight: 400, textAlign: 'center' }}>
            Your data was not found on these brokers.
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ScanCoverageCard;
